<template>
  <div class="graph-form-box">
    <el-form :inline="true" :model="searchData.searchQuery" class="graph-form-inline" @submit.prevent>
      <el-form-item v-for="(item, index) in searchData.inputList" :key="index" v-if="!item.hide" :label="item.label">
        <el-input v-if="item.type === 'input'" clearable v-model="searchData['searchQuery'][item.prop]"
          :placeholder="item.placeholder" size="small" suffix-icon="Search" @keyup.enter.native="onSubmit" />
        <el-input-number v-if="item.type === 'number'" clearable controls-position="right" :min="item.min || 1"
          :max="item.max || 99999" v-model="searchData['searchQuery'][item.prop]" :placeholder="item.placeholder"
          size="small" @keyup.enter.native="onSubmit" />
        <el-date-picker v-if="item.type === 'date'" class="el-date" v-model="searchData['searchQuery'][item.prop]"
          type="date" :disabled-date="item.disabledDate || disabledDate" value-format="YYYY-MM-DD"
          :disabled="item.disabled" :placeholder="item.placeholder || '请选择'" size="small" @change="change" />
        <el-date-picker v-if="item.type === 'month'" class="el-date" v-model="searchData['searchQuery'][item.prop]"
          type="month" :disabled-date="item.disabledDate || disabledDate" value-format="YYYY-MM"
          :disabled="item.disabled" :placeholder="item.placeholder || '请选择'" size="small" @change="change" />
        <el-date-picker v-if="item.type === 'dateRange'" v-model="searchData['searchQuery'][item.prop]"
          value-format='YYYY-MM-DD' type="daterange" :disabled-date="item.disabledDate || disabledDate"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="change" size="small"
          @calendar-change="calendarChange" />
        <el-date-picker v-if="item.type === 'dateTimeRange'" v-model="searchData['searchQuery'][item.prop]"
          value-format='YYYY-MM-DD HH:mm:ss' type="datetimerange" :disabled-date="item.disabledDate || disabledDate"
          size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-select v-if="item.type === 'select'" class="el-select" v-model="searchData['searchQuery'][item.prop]"
          :filterable="item.dictionary.length > 10" :disabled="item.disabled" clearable size="small"
          :multiple="item.multiple" :placeholder="item.placeholder || '请选择'">
          <el-option v-for="(items, indexs) in item.dictionary" :key="indexs" :label="items.label"
            :value="(typeof searchData['searchQuery'][item.prop]) === 'number' ? items.id : items.id.toString()">
          </el-option>
        </el-select>
        <el-cascader v-if="item.type === 'caScaDer'" class="common-casCaDer" :ref="item.ref"
          v-model="searchData['searchQuery'][item.prop]" :props="item.casCaDerProps" :options="item.options"
          :show-all-levels="item.casCaDerProps ? item.casCaDerProps.Show : true" :disabled="item.disabled" size="small"
          :placeholder="item.placeholder || '请选择'" clearable></el-cascader>
        <div v-if="!item.type">
          <slot :name="item.prop"></slot>
        </div>
      </el-form-item>
      <el-form-item v-show="searchData.inputList.length > 0">
        <el-button type="primary" size="small" @click="onSubmit">搜索</el-button>
        <!--        <el-button type="primary" @click="onResetting">重置</el-button>-->
      </el-form-item>
    </el-form>
    <div>
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    searchData: {
      type: Object,
      default: _ => {
        return {
          inputList: [], //  搜索类型列表
          searchQuery: {} //  参数
        };
      }
    } // 表格数据
  },
  methods: {
    onSubmit () {
      this.$emit('onSearch');
    },
    change (date) {
      this.$emit('dateChange', date);
    },
    calendarChange (date) {
      this.$emit('calendarChange', date);
    },
    disabledDate (date) {
      return date.getTime() >= Date.now();
    }
  }
}
</script>
<style scoped lang="scss">
.graph-form-box {
  flex: 1;
  padding: 18px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .graph-form-inline {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicSearch.vue